import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-apps-internas',
  templateUrl: './apps-internas.component.html',
  styleUrls: ['./apps-internas.component.css']
})
export class AppsInternasComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
